import React, { Component } from 'react';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import NameOnTicketList from '../components/NameOnTicketList';
import { isKioskMode } from '../../../selectors/ui';
import { setTicketName } from '../../../actions/tickets';
import { setBundleSaleName } from '../../../actions/bundle-sales';
import { orderRequiresNames } from '../../../selectors/request';
import { initKeyboard } from 'checkout/actions/keyboard';
import Translation from "../../../../shared/Translation";

class NameOnTicketContainer extends Component {
    render() {
        if (!this.props.nameRequired) {
            return null;
        }
        if (this.props.isKioskMode) {
            return this.getNameTicketLists();
        }
        return(
            <section className="checkout-form__section">
                <h4 className="checkout-form__sub-heading"><Translation>{"checkout__name_on_ticket"}</Translation></h4>
                {this.getNameTicketLists()}
            </section>
        )
    }

    /**
     * Group tickets and bundles that require name by event
     */
    groupItems = () => {
        const grouped = {};
        this.props.tickets.forEach(ticket => {
            if (!!ticket?.requires_name && !!ticket?.event_id) {
                if (!grouped[ticket.event_id]) {
                    grouped[ticket.event_id] = {
                        eventName: ticket.event_name,
                        tickets: [],
                        bundles: [],
                    };
                }
                grouped[ticket.event_id].tickets.push(ticket);
            }
        });
        this.props.bundles.forEach(bundle => {
            if (!!bundle?.requires_name && !!bundle?.event_id) {
                if (!grouped[bundle.event_id]) {
                    grouped[bundle.event_id] = {
                        eventName: bundle.event_name,
                        tickets: [],
                        bundles: [],
                    };
                }
                grouped[bundle.event_id].bundles.push(bundle);
            }
        });
        return grouped;
    }

    setTicketName = (id, name) => {
        this.props.setTicketName(id, name);
    }

    setBundleName = (id, name) => {
        this.props.setBundleSaleName(id, name);
    }

    getNameTicketLists = () => {
        const grouped = this.groupItems();
        if (!Object.keys(grouped).length) {
            return null;
        }
        return Object.values(grouped).map((group, index) => {
            return (
                <NameOnTicketList
                    key={index}
                    isKiosk={this.props.isKioskMode}
                    eventName={group.eventName}
                    tickets={group.tickets}
                    bundles={group.bundles}
                    bundleTickets={this.props.bundleTickets}
                    onSetTicketName={this.setTicketName}
                    onSetBundleName={this.setBundleName}
                    ticketNames={this.props.ticketNames}
                    bundleNames={this.props.bundleNames}
                    onInitKeyboard={this.props.initKeyboard}
                />
            )
        });
    }
}

const mapStateToProps = state => {
    return {
        nameRequired: orderRequiresNames(state),
        isKioskMode: isKioskMode(state),
        tickets: state.tickets.tickets,
        bundleTickets: state.tickets.bundleTickets,
        bundles: state.bundleSales.bundles,
        ticketNames: state.tickets.namesOnTickets,
        bundleNames: state.bundleSales.namesOnBundles,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setTicketName,
        setBundleSaleName,
        initKeyboard,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NameOnTicketContainer)
